import { render } from "./ExtranetBranchForm.vue?vue&type=template&id=fd78c13a&scoped=true"
import script from "./ExtranetBranchForm.vue?vue&type=script&lang=js"
export * from "./ExtranetBranchForm.vue?vue&type=script&lang=js"

import "./ExtranetBranchForm.vue?vue&type=style&index=0&id=fd78c13a&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd78c13a"]])

export default __exports__